<div class="items__img">
  <a href="https://www.orf.at/" target="_blank">
    <img
      src="https://images.www.check24.at/General_icons/orf-brick.svg"
      alt="orf"
    />
  </a>
</div>
<div class="items__img">
  <a href="https://oe3.orf.at/" target="_blank">
    <img src="https://images.www.check24.at/General_icons/oe3.png" alt="oe3" />
  </a>
</div>
<div class="items__img">
  <a href="https://www.krone.at/" target="_blank">
    <img
      src="https://images.www.check24.at/General_icons/krone.svg"
      alt="krone"
    />
  </a>
</div>
<div class="items__img">
  <a href="https://www.sky.at/" target="_blank">
    <img
      src="https://images.www.check24.at/General_icons/sky-color.webp"
      alt="Sky_Master"
    />
  </a>
</div>
<div class="items__img">
  <a href="https://www.prosieben.at/" target="_blank">
    <img
      src="https://images.www.check24.at/General_icons/seven-color.png"
      alt="ikone"
  /></a>
</div>
<div class="items__img">
  <a href="https://www.sat1.at/" target="_blank">
    <img
      src="https://images.www.check24.at/General_icons/SAT1.svg"
      alt="SAT1"
    />
  </a>
</div>
<div class="items__img">
  <a href="https://www.rtl.de/" target="_blank">
    <img
      src="https://images.www.check24.at/General_icons/rtl-color.png"
      alt="RTL"
    />
  </a>
</div>
<div class="guarantees__img">
  <img
    src="https://images.www.check24.at/General_icons/CustomerChampion.webp"
    alt="customerChampion"
  />
</div>

<div class="ekomi">
  <div class="ekomi__logo">
    <img
      src="/resultpage/assets/icons/ekomi.webp"
      alt="ekomi"
      width="40"
      height="40"
    />
  </div>
  <div class="ekomi__rating">
    <span>
      <strong>{{ rating }}</strong
      >&nbsp;/&nbsp;5
    </span>
    <svg-icon
      src="/resultpage/assets/icons/c24-app-promo-stars.svg"
      alt="Rating"
      class="rating"
    ></svg-icon>
  </div>
  <p class="ekomi__text">
    <a
      href="https://www.check24.at/unternehmen/bewertungen/ekomi"
      target="_blank"
      rel="noreferrer"
      >{{ review_count }} Kundenbewertungen</a
    >
  </p>
</div>
